import { useCallback } from 'react'
import { useAudioStore } from '@/lib/store/audio-store'

export default function useAudioPlayer(src: string | null | undefined) {
  const currentSrc = useAudioStore((state) => state.currentSrc)
  const storeIsPlaying = useAudioStore((state) => state.isPlaying)
  const storeIsLoading = useAudioStore((state) => state.isLoading)
  const storeCurrentTime = useAudioStore((state) => state.currentTime)
  const storeDuration = useAudioStore((state) => state.duration)
  const play = useAudioStore((state) => state.play)
  const storeStop = useAudioStore((state) => state.stop)
  const storeSeek = useAudioStore((state) => state.seek)

  const playAudio = useCallback(
    (startTime?: number) => {
      if (!src) {
        return
      }

      play(src, startTime)
    },
    [play, src]
  )

  const stopAudio = useCallback(() => {
    if (currentSrc !== src) {
      return
    }
    storeStop()
  }, [currentSrc, storeStop, src])

  const seekAudio = useCallback(
    (time: number) => {
      if (currentSrc !== src) {
        return
      }
      storeSeek(time)
    },
    [currentSrc, storeSeek, src]
  )

  const isPlaying = storeIsPlaying && currentSrc === src
  const isLoading = isPlaying && storeIsLoading
  const currentTime = isPlaying ? storeCurrentTime : 0
  const duration = isPlaying ? storeDuration : 0

  return {
    isPlaying,
    isLoading,
    currentTime,
    duration,
    play: playAudio,
    stop: stopAudio,
    seek: seekAudio,
  }
}
